"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var classnames_1 = __importDefault(require("classnames"));
var GridColumn = function (_a) {
    var dusk = _a.dusk, children = _a.children, width = _a.width, _b = _a.size, size = _b === void 0 ? 'base' : _b;
    return (react_1.default.createElement("div", { "data-dusk": dusk, className: classnames_1.default(width, {
            'px-3': size === 'base',
            'px-6': size === 'lg',
        }) }, children));
};
exports.default = GridColumn;
//# sourceMappingURL=GridColumn.js.map